/* Shared Turnstile widget behavior for Alpine components.
   Not a registered Alpine.data() component itself - spread its return value
   into another component's returned object, then call initTurnstile() from
   that component's own init():

     return {
       ...turnstile("my-action"),
       init() {
         this.initTurnstile();
       },
       // ...the rest of the component
     };

   Expects the component's template to render a `x-ref="turnstile"` element
   with a `data-sitekey` attribute (see _includes/forms/_turnstile.twig) and
   to have already loaded the Cloudflare Turnstile script. */
export function turnstile(action) {
  let turnstileId = null;

  return {
    initTurnstile() {
      const el = this.$refs.turnstile;

      if (!el) {
        return;
      }

      const render = () => {
        turnstileId = window.turnstile.render(el, {
          sitekey: el.dataset.sitekey,
          action,
        });
      };

      const whenReady = () =>
        window.turnstile ? window.turnstile.ready(render) : setTimeout(whenReady, 50);

      whenReady();
    },

    resetTurnstile() {
      if (turnstileId !== null) {
        window.turnstile.reset(turnstileId);
      }
    },
  };
}
